import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const navigate = useNavigate();
  const [data, setdata] = useState({ name: "", email: "", password: "" });
  const onchange = (e) => {
    setdata({ ...data, [e.target.name]: e.target.value });
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`https://fullstack-backend-mtio.onrender.com/api/auth/createuser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: data.name, email: data.email, password: data.password }),
    });
    const json = await response.json();
    if (json.success) {
      localStorage.setItem("token", json.authtoken);
      alert("Signup successful! Welcome to iNotebook.");
      navigate("/");
    } else {
      alert("Signup failed: User may already exist or other error.");
    }
    console.log(json);
  };
  return (
    <div className="container my-5 p-4 bg-white rounded shadow-sm" style={{maxWidth:'500px'}}>
      <h2 className="mb-4 text-center" style={{color:'#3730a3'}}>Create Your Account</h2>
      <form onSubmit={handlesubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Name</label>
          <input type="text" className="form-control" name='name' onChange={onchange} id="name" required minLength={3} />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email address</label>
          <input type="email" className="form-control" name='email' onChange={onchange} id="email" aria-describedby="emailHelp" required />
          <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">Password</label>
          <input type="password" className="form-control" name='password' onChange={onchange} id="password" required minLength={5} />
        </div>
        <button type="submit" className="btn btn-primary w-100 py-2">Sign Up</button>
      </form>
    </div>
  );
}
